import { Box, Button } from '@factorialco/deprecated-design-system'
import Popover from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

export type MembershipAction =
  | { type: 'complete_consent'; consentUrl: string }
  | { type: 'resend_invitation'; membershipId: string }
  | { type: 'retry'; membershipId: string }
  | { type: 'complete_setup'; setupUrl: string }

interface Props {
  actions: MembershipAction[]
  onAction: (action: MembershipAction) => void
  disabled?: boolean
}

export const MembershipActionsMenu = ({ actions, onAction, disabled }: Props) => {
  if (actions.length === 0) return null

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd" paddingRight={'s16'}>
      <Popover type="list">
        <Popover.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </Popover.Trigger>
        <Popover.Content side="bottom" align="end">
          {actions.map((action, index) => (
            <Popover.TouchableOption
              key={index}
              onClick={() => onAction(action)}
              title={getActionTitle(action)}
              disabled={disabled}
            />
          ))}
        </Popover.Content>
      </Popover>
    </Box>
  )
}

const getActionTitle = (action: MembershipAction): string => {
  switch (action.type) {
    case 'complete_consent':
      return i18n.t('banking.account_memberships.actions.complete_consent')
    case 'resend_invitation':
      return i18n.t('banking.account_memberships.actions.resend_invitation')
    case 'retry':
      return i18n.t('banking.account_memberships.actions.retry')
    case 'complete_setup':
      return i18n.t('banking.account_memberships.actions.complete_setup')
  }
}
